import { useSelector } from 'react-redux';

import { isNewLineupPlanPorfileAndBillingPlan } from './feature-gate-helper';
import { FeatureFlagDeclarations } from '../feature-flags/feature-flag-declarations';
import { useFeatureFlag } from '../feature-flags/hooks/use-feature-flag';
import Global from '../store/global-selectors';

/**
 * Custom hook to check if AddOns feature is available.
 * @returns {{ isAddOnsFeatureEnabled: boolean, isAddonMenuItemVisible: boolean }}
 */
export const useAddOnsFeatureGate = () => {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enable2025Q2PlanFeatureGates);
  // Check available add-ons
  const { marketplaceAddOns = [], planProfileId, billingPlanId } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};
  // Check if add-ons are available
  const hasAddOns = marketplaceAddOns.length > 0;
  const isSellerOnFeatureGatedPlanProfile = isNewLineupPlanPorfileAndBillingPlan(planProfileId, billingPlanId);

  return {
    isAddOnsFeatureEnabled: isFeatureFlagEnabled ? hasAddOns : true,
    isAddonMenuItemVisible: !isSellerOnFeatureGatedPlanProfile,
  };
};
